export const serviceTermsURL = "/pdfs/RegulaminUslug.pdf";
export const activitiesTermsURL = "/pdfs/RegulaminZajec.pdf";
export const tripWinter2022TermsURL = "/pdfs/RegulaminZima.pdf";
export const tripSummer2023TermsURL = "/pdfs/RegulaminLato.pdf";
export const privacyTermsURL = "/pdfs/PolitykaPrywatnosci.pdf";
export const insuranceTermsURL = "/pdfs/Insurance.pdf";

export const requiredConsents = [
  "health",
  "healthProcessing",
  "knowledge",
  "insurance",
];

export const healthAgreement =
  "Potwierdzam że zgłoszony uczestnik/uczestnicy nie mają przeciwwskazań zdrowotnych do udziału w zajęciach i aktywnościach organizowanych przez Klub Sportteam Sp. z o.o.";
export const healthProcessingAgreement =
  "Wyrażam zgodę na przetwarzanie podanych danych osobowych i danych dotyczących stanu zdrowia w celu zapewnienia prawidłowej opieki w ramach usług świadczonych przez Klub Sportteam Sp. z o.o.";

export const communicationAgreement =
  "Wyrażam zgodę na otrzymywanie informacji dotyczących oferty zajęć sportowych, wyjazdów oraz innych produktów i usług oferowanych przez Klub Sportteam Sp. z o.o. w następującej formie:";

export const communicationMethods = {
  email: "wiadomość e-mail",
  text: "wiadomość SMS/MMS",
  call: "połączenia telefoniczne",
};

export const allConsents = [
  "knowledge",
  "health",
  "healthProcessing",
  "email",
  "text",
  "call",
];
